module.exports = __webpack_public_path__ + "static/media/Argos - Instances - Purple.6f23bf39.svg";